// Keep it sync with @indigo-ag/server middleware/shield_constants

export enum Permissions {
  FA_SCOPE_ALL = 'app:scope:all',
  FA_SCOPE_BR = 'app:scope:br',
  FA_ADMIN = 'app:admin',
  FA_INTERNAL = 'financing-admin:internal',
  FA_EXTERNAL = 'financing-admin:external',
  FA_CREDIT = 'financing-admin:credit',
  FA_SUPPLY = 'financing-admin:supply',
  FA_CREDIT_COMMON = 'financing-admin:credit-common',
  FA_CREDIT_LEAD = 'financing-admin:credit-lead',
  FA_CREDIT_COMMITTEE = 'financing-admin:credit-committee',
  FA_COMMERCIAL = 'financing-admin:commercial',
  FA_EXTERNAL_LEGAL = 'financing-admin:external-legal',
  FA_EXTERNAL_CREDIT = 'financing-admin:external-credit',
  FA_EXTERNAL_FIELD_MONITORING = 'financing-admin:external-field-monitoring',
  FA_SECRETARY = 'financing-admin:secretary'
}

export enum Scope {
  GLOBAL = 'app:scope:all',
  BR = 'app:scope:br',
  UNSET = ''
}

export enum RoleNames {
  FINANCING_ADMIN_SYSTEM = 'financing-admin-system',
  FINANCING_ADMIN_BR_CREDIT = 'financing-admin-br-credit',
  FINANCING_ADMIN_BR_CREDIT_MANAGER = 'financing-admin-br-credit-lead',
  FINANCING_ADMIN_BR_CREDIT_SUPERVISOR = 'financing-admin-br-credit-supervisor',
  FINANCING_ADMIN_BR_FINANCE_DIRECTOR = 'financing-admin-br-finance-director',
  FINANCING_ADMIN_BR_COMMERCIAL_DIRECTOR = 'financing-admin-br-commercial-director'
}
